import { R7E_IApplication, r7eBaseApp, R7eAccountTypeError, R7E_HomeItem, R7E_NavBarData } from '@r7e/shared';

class R7E_ConsumerApplication extends R7E_IApplication {
    constructor(app) {
        super('consumer', app)
    }

    // --- NavBar Setup ---
    getNavBarData() {
        const nav = new R7E_NavBarData(this, 'navbar_consumer.aggregator');
        nav.setItemsBuilder((curr) => {
            const app = curr.app;
            const b = app.base.hasAccessToCurrentService();
            const items = [
                // { route: "/info", title_id: 'navbar_consumer.consumerInfo', condition: b },
                { route: "/reports", title_id: 'navbar_consumer.reports', condition: b },
                { route: "/invoices", title_id: 'navbar_consumer.invoices', condition: b },
                { route: "/transactions", title_id: 'navbar_consumer.transactions', condition: b }
            ];
            return items;
        });
        return nav;
      }
    // --- end of NavBar Setup ---    

    getHomeItems() {
        const row1 = [];
        const invoices = new R7E_HomeItem(this, 'home_consumer.invoices', 'home_consumer.invoicesDescription', '/invoices');
        invoices.setIcon('fa-solid fa-list');
        invoices.setCSSClass('box-invoices');
        invoices.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(invoices);

        const accountInfo = new R7E_HomeItem(this, 'home_consumer.myAccount', 'home_consumer.myAccountDescription', '/account');
        accountInfo.setIcon('fa-solid fa-user');
        accountInfo.setCSSClass('box-account-info');
        accountInfo.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        row1.push(accountInfo);

        // const row2 = [];    

        // const transactions = new R7E_HomeItem(this, 'home_consumer.transactions', 'home_consumer.transactionsDescription', '/transactions');
        // transactions.setIcon('fa-solid fa-list');
        // transactions.setCSSClass('box-transactions');
        // transactions.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        // row2.push(transactions);


        // const reports = new R7E_HomeItem(this, 'home_consumer.reports', 'home_consumer.reportsDescription', '/reports');
        // reports.setIcon('fa-solid fa-chart-bar');
        // reports.setCSSClass('box-reports');
        // reports.setCondition(() => this.isAuthenticated() && this.hasAccessToCurrentService());
        // row2.push(reports);

        // return [row1, row2];
        return [row1];
    }
    getAvailableExperimentations() {
        const availableExperimentations = super.getAvailableExperimentations();
        availableExperimentations.push('transactions');
        return availableExperimentations; 
    }

    getProfileFieldsSettings() {
        const profile_fields = super.getProfileFieldsSettings();
        return profile_fields;
    }
    
    setupPages() { return super.setupPages().concat(["/invoices"]); }


// --- Consumer Endpoints ---

    async getUserConsumptions(params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get('consumer/consumptions/', { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching consumptions:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getConsumption(identifier, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`consumer/consumption/${identifier}`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching consumption:", error.response ? error.response.data : error.message);
            throw error;
        }
    }


    async newConsumption(payload) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.post('consumer/consumption/', payload);
            return response.data;
        } catch (error) {
            console.error("Error creating consumption:", error.response ? error.response.data : error.message);
            throw error;
        }
    }


    /**
     * Fetch usage reports for a consumer
     * @param {string} consumerId - The consumer's ID (username)
     * @param {object} params - Optional query params (offset, count)
     * @returns {Promise<object>} Usage report list
     */
    async getConsumerUsageReports(consumerId, params = {}) {
        try {
            const response = await this.base.apiR7eClient.get(`consumer/${consumerId}/reports/`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching usage reports:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch invoices for a consumer
     * @param {string} consumerId - The consumer's ID (username)
     * @param {object} params - Optional query params (offset, count)
     * @returns {Promise<object>} Invoice list
     */
    async getConsumerInvoices(consumerId, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`consumer/${consumerId}/invoices/`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching invoices:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    async getConsumerInvoicePublishersList(consumerId, startDate, endDate, params = {}) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`consumer/${consumerId}/invoices/${startDate}/${endDate}/publishers/`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching invoice data list:", error.response ? error.response.data : error.message);
            throw error;
        }
    }

    /**
     * Fetch a single invoice publisher for a consumer
     * @param {string} consumerId - The consumer's ID (username)
     * @param {string} startDate - The start date
     * @param {string} endDate - The end date
     * @param {string} publisher - The publisher
     * @returns {Promise<object>} Invoice publisher detail for consumer
     */
    async getConsumerInvoicePublisher(consumerId, startDate, endDate, publisher) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`consumer/${consumerId}/invoices/${startDate}/${endDate}/publisher/${publisher}/`);
            return response.data;
        } catch (error) {
            console.error("Error fetching invoice publisher for consumer:", error.response ? error.response.data : error.message);
            throw error;
        }
    }
    async getConsumerInvoiceForPeriod(consumerId, startDate, endDate) {
        await this.base.auth.refreshTokenIfNeeded();
        try {
            const response = await this.base.apiR7eClient.get(`consumer/${consumerId}/invoices/${startDate}/${endDate}/invoice.json`);
            return response.data;
        } catch (error) {
            console.error("Error fetching invoice for consumer for period:", error.response ? error.response.data : error.message);
            throw error;
        }
    }
}


export {R7eAccountTypeError, R7E_ConsumerApplication, r7eBaseApp };
export default {  ...R7eAccountTypeError, R7E_ConsumerApplication, r7eBaseApp }
